// import { createSlice } from '../../utils/npm'

// let initialState = {
//     isloading: false,
// }

// const masterSlice = createSlice({
//     name: 'masterslice',
//     initialState: initialState,
//     reducers: {
//         startMasterLoding(initialState, action) {
//             initialState.isloading = action?.payload
//         },
//         stopMasterLoding(initialState, action) {
//             initialState.isloading = action?.payload
//         },
//     },
// });

// export const { startMasterLoding, stopMasterLoding } = masterSlice.actions;
// export default masterSlice.reducer;


import { createSlice } from '../../utils/npm'

let initialState = {
    isloading: false,
    ipoHomePageList : [],
    filterGlobal : "" ,
    headerLoad : false ,
    fooerLoad : false
}

const masterSlice = createSlice({
    name: 'masterslice',
    initialState: initialState,
    reducers: {
        startMasterLoding(initialState, action) {
            initialState.isloading = action?.payload
        },
        stopMasterLoding(initialState, action) {
            initialState.isloading = action?.payload
        },
        setIpoHomePageLIstData (initialState , action) {
            initialState.ipoHomePageList = action?.payload
        },
        setFilterGlobal(initialState , action) {
            initialState.filterGlobal = action?.payload
        },
        setHeaderLoad(initialState , action) {
            initialState.headerLoad = action?.payload
        },
        setFooterLoad(initialState , action) {
            initialState.fooerLoad = action?.payload
        }
    },
});

export const { startMasterLoding, stopMasterLoding , setIpoHomePageLIstData , setFilterGlobal , setHeaderLoad , setFooterLoad} = masterSlice.actions;
export default masterSlice.reducer;